export default __webpack_public_path__ + "static/media/5.d581b3e9.gif";